/* INTEGY V772.3 hotfix: refresh company price context on navigation, login/logout, location switching and BFCache restore. */
(function () {
  'use strict';
  if (window.INTEGY_V772_B2B_FRESHNESS) return;
  window.INTEGY_V772_B2B_FRESHNESS = true;
  var root = document.documentElement;
  var signature = root.hasAttribute('data-integy-b2b') ?
    'business:' + (root.getAttribute('data-integy-b2b-location') || '') : 'retail';
  var storageKey = 'integy:b2b:page-context:v772';
  var marker = '_integy_b2b_refresh';
  var working = false;

  function read() {
    try { return window.sessionStorage.getItem(storageKey); }
    catch (e) { return null; }
  }
  function remember() {
    try { window.sessionStorage.setItem(storageKey, signature); }
    catch (e) {}
  }
  function refresh() {
    if (working) return;
    working = true;
    remember();
    document.querySelectorAll('[data-integy-b2b-refresh]').forEach(function (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Refreshing prices…';
    });
    var url = new URL(window.location.href);
    url.searchParams.set(marker, String(Date.now()));
    window.location.replace(url.pathname + url.search + url.hash);
  }
  document.addEventListener('click', function (event) {
    var node = event.target;
    var button = node && node.closest ? node.closest('[data-integy-b2b-refresh]') : null;
    if (!button) return;
    event.preventDefault();
    refresh();
  });
  window.addEventListener('pageshow', function (event) {
    var url;
    try { url = new URL(window.location.href); }
    catch (e) { remember(); return; }
    var forced = url.searchParams.has(marker);
    var prior = read();
    var switched = prior !== null && prior !== signature;
    var fromBusiness = prior && prior.indexOf('business:') === 0;
    var restoredBusiness = event && event.persisted && (signature !== 'retail' || fromBusiness);
    if (!forced && (switched || restoredBusiness)) {
      refresh();
      return;
    }
    remember();
    if (forced) {
      try {
        url.searchParams.delete(marker);
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (e) {}
    }
  });
})();